import {
  ChatBotContext,
  useAppLauncherItems,
  UserInitials,
} from '@monash/portal-frontend-common';
import React, { useContext } from 'react';
import { AppLauncher } from '@monash/portal-react';
import SearchButton from './search-button/SearchButton';
import getUserInitialsCustomSections from '@/components/utilities/user-initials-custom-sections/get-user-initials-custom-sections';
import { DataContext } from '@/components/providers/data-provider/DataProvider';

const TopNavItems = ({ setShowThemer }) => {
  const { avatar, profileData } = useContext(DataContext);
  const { ChatBotButton } = useContext(ChatBotContext);
  const { items: appLauncherItems } = useAppLauncherItems();
  const customSections = getUserInitialsCustomSections({ setShowThemer });

  return (
    <>
      <SearchButton />
      <AppLauncher items={appLauncherItems} />
      <ChatBotButton data-tracking-event="topnav-chatbot" />
      <UserInitials
        avatarData={avatar}
        profileData={profileData}
        getData={false}
        buttonProps={{ 'data-tracking-event': 'topnav-user-menu' }}
        appVersion={import.meta.env.VITE_VERSION}
      >
        {customSections}
      </UserInitials>
    </>
  );
};

export default TopNavItems;
